import useOnSnippingAnnotationChangedOrSelected from './useOnSnippingAnnotationChangedOrSelected';

export default useOnSnippingAnnotationChangedOrSelected;